import { useTranslation } from "@outschool/localization";
import {
  createDayjs,
  DATE_FORMAT,
  dayjs,
  OUTSCHOOL_TIMEZONE,
} from "@outschool/time";
import { useSession } from "@outschool/ui-auth";
import { Banner } from "@outschool/ui-legacy-component-library";
import Cookie from "js-cookie";
import React, { useEffect, useState } from "react";

import * as Env from "../../../shared/Env";

const UpcomingMaintenanceBanner: React.FC = React.memo(() => {
  const { isLoggedIn } = useSession();
  const { t } = useTranslation(
    "client\\components\\banners\\UpcomingMaintenanceBanner",
  );
  const dismissalCookieName = "dismissed-upcoming-maintenance-banner";
  const [hideBanner, setHideBanner] = useState(true);

  useEffect(() => {
    const cookieExists = Cookie.get(dismissalCookieName);
    if (!cookieExists) {
      setHideBanner(false);
    }
  }, [dismissalCookieName]);

  const handleClose = () => {
    setHideBanner(true);
    Cookie.set(dismissalCookieName, "true", { expires: 1 });
  };

  let isMaintenanceUpcoming = false;
  const maintenanceDate = Env.UPCOMING_MAINTENANCE_DATE?.trim();
  if (
    maintenanceDate &&
    createDayjs(maintenanceDate, DATE_FORMAT, true).isValid() &&
    new Date() <
      dayjs
        .tz(
          `${maintenanceDate} 19:00:00`,
          "YYYY-MM-DD HH:mm:ss",
          OUTSCHOOL_TIMEZONE,
        )
        .toDate()
  ) {
    isMaintenanceUpcoming = true;
  }

  if (!isMaintenanceUpcoming || !isLoggedIn || hideBanner) {
    return null;
  }

  const maintenanceDateFormatted = dayjs
    .tz(maintenanceDate, DATE_FORMAT, OUTSCHOOL_TIMEZONE)
    .format("MMMM D, YYYY");

  return (
    <Banner closable={true} onClose={handleClose} sx={{ textAlign: "center" }}>
      {t(
        "Scheduled maintenance will occur on {{maintenanceDate}} from 7:00 PM to 9:30 PM PT. Classes will continue as usual, but account and enrollment management services may be temporarily unavailable.",
        { maintenanceDate: maintenanceDateFormatted },
      )}{" "}
      <a href="https://support.outschool.com/en/articles/9201176-using-the-outschool-website-during-scheduled-maintenance">
        {t("Learn More")}
      </a>
    </Banner>
  );
});

export default UpcomingMaintenanceBanner;
